import IpsToast from './IpsToast.vue';
import '../../../styles/custom.scss';

export default IpsToast;
